<template>
  <div class="consumption-amount">
    <div class="consumption-title">
      <i class="el-icon-document"></i>
      <span>消费金额记录</span>
    </div>

    <el-table
      :data="consumptionRecords"
      border
      stripe
      style="width: 100%">
      <el-table-column
        type="index"
        label="序号"
        width="60"
        align="center">
      </el-table-column>
      <el-table-column
        prop="iccid"
        label="ICCID"
        width="180"
        align="center">
      </el-table-column>
      <el-table-column
        prop="changeTime"
        label="变更时间"
        width="160"
        align="center">
      </el-table-column>
      <el-table-column
        prop="changeType"
        label="变更类型"
        width="100"
        align="center">
      </el-table-column>
      <el-table-column
        prop="remark"
        label="来源"
        width="120"
        align="center">
      </el-table-column>
      <el-table-column
        prop="beforeAmount"
        label="变更前金额"
        width="120"
        align="center">
      </el-table-column>
      <el-table-column
        prop="changeAmount"
        label="操作金额"
        width="120"
        align="center">
      </el-table-column>
      <el-table-column
        prop="afterAmount"
        label="变更后金额"
        width="120"
        align="center">
      </el-table-column>
      <el-table-column
        prop="operator"
        label="操作人"
        width="120"
        align="center">
      </el-table-column>
      <el-table-column
        prop="note"
        label="备注"
        min-width="120"
        align="center">
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  name: 'ConsumptionAmount',
  props: {
    records: {
      type: Array,
      default: () => []
    },
    orderData: {
      type: Object,
      default: () => ({})
    }
  },
 
  data() {
    return {
      tableData: [
        {
          iccid: '',
          changeTime: '',
          changeType: '',
          remark: '',
          beforeAmount: '',
          changeAmount: '',
          afterAmount: '',
          operator: '',
          note: ''
        },
       
      ]
    }
  },
  computed: {
    consumptionRecords() {
      if (this.records && this.records.length > 0) {
        console.log('ConsumptionAmount接收到的所有记录:', this.records);
        console.log('记录数量:', this.records.length);
        
        // 转换所有记录为表格需要的格式，不进行筛选
        const mappedRecords = this.records.map((record, index) => {
          console.log(`处理第${index + 1}条记录:`, record);
          
          // 根据record_source获取来源描述
          let remarkText = '';
          if (record.record_source === 8) {
            remarkText = '充值套餐扣除';
          } else if (record.record_source === 5) {
            remarkText = '充值';
          } else {
            remarkText = record.record_source_str || '其他';
          }
          
          // 确保所有属性都有值，避免undefined
          const mappedRecord = {
            iccid: record.card_id || this.orderData.cardId || '',
            changeTime: record.create_date || '',
            changeType: record.record_type || '扣除',
            remark: remarkText,
            beforeAmount: record.before_money || 0,
            changeAmount: record.op_money || 0,
            afterAmount: record.after_money || 0,
            operator: record.agent_name || 'system',
            note: record.meal_name || record.remark || ''
          };
          
          console.log(`处理结果:`, mappedRecord);
          return mappedRecord;
        });
        
        console.log('转换后的记录:', mappedRecords);
        return mappedRecords;
      }
      console.log('没有记录或records为空');
      return [];
    }
  },
  mounted() {
    console.log('ConsumptionAmount组件挂载完成，records:', this.records);
    console.log('ConsumptionAmount组件挂载完成，records长度:', this.records.length);
    console.log('ConsumptionAmount组件挂载完成，orderData:', this.orderData);
    
    // 详细检查每条记录
    if (this.records && this.records.length > 0) {
      this.records.forEach((record, index) => {
        // console.log(`记录 ${index + 1}:`, record);
        // console.log(`记录 ${index + 1} 的 record_type:`, record.record_type);
        // console.log(`记录 ${index + 1} 的 op_money:`, record.op_money);
        // console.log(`记录 ${index + 1} 的 record_source:`, record.record_source);
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.consumption-amount {
  margin-top: 20px;
  background-color: #e3ebf4;
  border-radius: 4px;
  padding: 10px;

  .consumption-title {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    font-size: 14px;
    color: #363739;

    i {
      margin-right: 6px;
      font-size: 16px;
    }
  }

  .el-table {
    margin-bottom: 20px;
  }
}
</style>
